import React from "react";
import Benefits from "./service-single-components/benefits";
import Services from "../Services";


const ServiceSingleSection = () => {
  return (
    <section className="wpo-service-single-section section-padding-one">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-service-single-wrap">
              <div className="wpo-service-single-content">
                <div className="wpo-service-single-content-des">
                  <h2>
                    Como construir equipes de alta performance com estratégias
                    de Recursos Humanos
                  </h2>
                  <p>
                    Na Thomas Talent RH, acreditamos que o sucesso de uma
                    organização está diretamente ligado à gestão estratégica de
                    pessoas. Desenvolver equipes de alta performance exige mais
                    do que apenas encontrar talentos; é necessário entender a
                    cultura da empresa, planejar o crescimento profissional e
                    investir no desenvolvimento contínuo de competências. Nossa
                    atuação é focada em processos humanizados, ágeis e
                    personalizados, que transformam talentos em resultados e
                    constroem um ambiente organizacional saudável e produtivo.
                  </p>
                  <p>
                    Deixe a gestão de pessoas com a Thomas Talent. Assim, sua
                    empresa ganha autonomia para focar no que realmente importa:
                    crescer e inovar.
                  </p>
                </div>
              </div>
              <Services />
              <Benefits />

            
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSingleSection;
